const LangEgiftFooter = {
	footer: {
		items: [
			{
				title: "about",
				subItems: ["about-heritage", "about-company", "about-career"],
			},
			{
				title: "service",
				subItems: ["service-faq"],
			},
			{
				title: "quickLink",
				subItems: ["quickLink-locator", "quickLink-partner"],
			},
		],
		subItems: ["accessability", "privacy", "terms", "sitemap"],
		about: {
			path: [
				"https://en.starbucks.vn/about-us/",
				"https://www.starbucks.vn/v%E1%BB%81-ch%C3%BAng-t%C3%B4i/",
			],
			text: ["ABOUT US", "VỀ CHÚNG TÔI"],
		},
		service: {
			path: [
				"https://en.starbucks.vn/customer-service/",
				"https://www.starbucks.vn/d%E1%BB%8Bch-v%E1%BB%A5-kh%C3%A1ch-h%C3%A0ng/",
			],
			text: ["CUSTOMER SERVICE", "DỊCH VỤ KHÁCH HÀNG"],
		},
		quickLink: {
			path: ["/", "/"],
			text: ["QUICK LINKS", "LIÊN KẾT NHANH"],
		},
		"about-heritage": {
			path: [
				"https://en.starbucks.vn/about-us/our-heritage/",
				"https://www.starbucks.vn/v%E1%BB%81-ch%C3%BAng-t%C3%B4i/di-s%E1%BA%A3n/",
			],
			text: ["Our Heritage", "Di sản"],
		},
		"about-company": {
			path: [
				"https://en.starbucks.vn/about-us/company-information/",
				"https://www.starbucks.vn/v%E1%BB%81-ch%C3%BAng-t%C3%B4i/c%C3%B4ng-ty/",
			],
			text: ["Our Company", "Công ty"],
		},
		"about-career": {
			path: [
				"https://en.starbucks.vn/about-us/career-center/",
				"https://www.starbucks.vn/v%E1%BB%81-ch%C3%BAng-t%C3%B4i/c%C6%A1-h%E1%BB%99i-ngh%E1%BB%81-nghi%E1%BB%87p/",
			],
			text: ["Career Center", "Cơ hội nghề nghiệp"],
		},
		"service-faq": {
			path: [
				"https://en.starbucks.vn/customer-service/frequently-asked-questions/",
				"https://www.starbucks.vn/d%E1%BB%8Bch-v%E1%BB%A5-kh%C3%A1ch-h%C3%A0ng/c%C3%A2u-h%E1%BB%8Fi-th%C6%B0%E1%BB%9Dng-g%E1%BA%B7p/",
			],
			text: ["Frequently Asked Questions", "Câu hỏi Thường Gặp"],
		},
		"quickLink-locator": {
			path: [
				"https://en.starbucks.vn/store-locator/",
				"https://www.starbucks.vn/b%E1%BB%99-%C4%91%E1%BB%8Bnh-v%E1%BB%8B-c%E1%BB%ADa-h%C3%A0ng",
			],
			text: ["Store Locator", "Bộ định vị Cửa hàng"],
		},
		"quickLink-partner": {
			path: ["https://www.starbucks.com/", "https://www.starbucks.com/"],
			text: ["For Partners", "Dành cho Đối tác"],
		},
		"current-language": ["English (US)", "Tiếng Việt (VN)"],
		accessability: {
			path: [
				"https://en.starbucks.vn/about-us/company-information/online-policies/web-accessibility",
				"https://www.starbucks.vn/v%E1%BB%81-ch%C3%BAng-t%C3%B4i/c%C3%B4ng-ty/ch%C3%ADnh-s%C3%A1ch-tr%E1%BB%B1c-tuy%E1%BA%BFn/kh%E1%BA%A3-n%C4%83ng-truy-c%E1%BA%ADp-web",
			],
			text: ["Web Accessibility", "Khả năng truy cập Web"],
		},
		privacy: {
			path: [
				"https://en.starbucks.vn/about-us/company-information/online-policies/privacy-statement",
				"https://www.starbucks.vn/v%E1%BB%81-ch%C3%BAng-t%C3%B4i/c%C3%B4ng-ty/ch%C3%ADnh-s%C3%A1ch-tr%E1%BB%B1c-tuy%E1%BA%BFn/chi-nh-sa-ch-ba-o-m%C3%A2-t-th%C3%B4ng-tin",
			],
			text: ["Privacy Statement", "Chính Sách Bảo Mật Thông Tin"],
		},
		terms: {
			path: [
				"https://en.starbucks.vn/about-us/company-information/online-policies/terms-of-use",
				"https://www.starbucks.vn/v%E1%BB%81-ch%C3%BAng-t%C3%B4i/c%C3%B4ng-ty/ch%C3%ADnh-s%C3%A1ch-tr%E1%BB%B1c-tuy%E1%BA%BFn/%C4%91i%E1%BB%81u-kho%E1%BA%A3n-s%E1%BB%AD-d%E1%BB%A5ng",
			],
			text: ["Terms of Use", "Điều khoản Sử dụng"],
		},
		sitemap: {
			path: [
				"https://en.starbucks.vn/site-map",
				"https://www.starbucks.vn/site-map",
			],
			text: ["Site Map", "Sơ đồ Trang web"],
		},
		cookie: {
			path: ["", ""],
			text: ["Cookie Preferences", "Tùy Chọn Cookie"],
		},
		copyright: [
			"© 2019 Starbucks Coffee Company. All rights reserved.",
			"© 2019 Starbucks Coffee Company. Mọi quyền được bảo lưu.",
		],
	},
}

export default LangEgiftFooter



// WEBPACK FOOTER //
// ./src/resources/modules/LangEgiftFooter.js